import { render, staticRenderFns } from "./ProjectRegistrations.vue?vue&type=template&id=32797978&"
import script from "./ProjectRegistrations.vue?vue&type=script&lang=js&"
export * from "./ProjectRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectRegistrations.vue"
export default component.exports